import { paths } from '@/config';
import React from 'react';
import './style.scss';

const index = () => {
  return (
    <div className="container">
      <div className="container__inner">
        <h1>Stripeに関してよくある質問</h1>
        <p className="faq__notice">
          Stripeの登録画面および審査項目は随時変更されるため、画面上に「必要な対応」「申告書を提出」「本人確認」「追加情報の提出」等が表示されている場合は、Stripe画面上の案内を優先してご対応ください。
          <br />
          未対応の場合、売上金の入金が保留・停止されることがあります。
        </p>
        <div className="faq">
          {/* 追加情報提出を求められた場合の項目をどのように入力すればいいですか？ */}
          <div className="faq__item">
            <p className="faq__heading">
              追加情報提出を求められた場合の項目をどのように入力すればいいですか？
            </p>
            <div className="faq__answer">
              <p className="title">
                ①「開業届、もしくは確定申告書」をお持ちでない理由の入力方法
              </p>
              <p>
                個人の出品者様が情報ご提示できない場合、ご提示できない理由（個人出品のため開業届・確定申告書を持ち合わせていない）などを記載してください
              </p>

              <p className="title">
                ②「ビジネスに関する補足書類（ライセンスなど）」欄の入力・アップロード方法
              </p>
              <p>
                ①でご回答いただいた内容に順じて、個人事業主では無い個人出品者である旨などを記載していただき提出してください
              </p>

              <p className="title">
                ③「オプションのビジネス情報入力欄」の入力方法
              </p>
              <p>
                ①でご回答いただいた内容に順じて、個人事業主では無い個人出品者である旨などを記載していただき提出してください
              </p>

              <p className="title">
                ④ 決済を受け付けるために使用する Stripe 製品を教えてください。
              </p>
              <p>Connect</p>

              <p className="title">⑤ Stripe を介して何を販売していますか？</p>
              <p>FishSaleに出品する予定の商品（鮮魚 など）</p>

              <p className="title">
                ⑥ このアカウントに関連する、主要な顧客向けウェブサイトの URL
                をご提示ください。
              </p>
              <p>
                <a href={paths.introduction.howto_sales_account}>
                  Stripeの登録方法について
                </a>
                <b>STEP6</b>で説明しているURL（出品者様のマイページ）
              </p>

              <p className="title">
                ⑦ 特定商取引法に基づくビジネス情報を記載したページの URL
                をご提示ください。
              </p>
              <p>https://about.freshspeed.net/law.html</p>

              <p className="title">
                ⑧ ・ビジネスの登録書類のコピーをお持ちですか？
                ・お客様のビジネスに該当する提供可能な補足書類をお持ちですか？
              </p>
              <p>
                ① でご回答いただいた内容に順じて、
                <b>
                  個人事業主では無い個人出品者である旨などを記載していただき
                </b>
                提出してください
              </p>

              <br />
              <p>
                ご回答いただき次第、Stripeにて内容を確認、必要であれば追加情報提出ご依頼などのご連絡がございます。
              </p>
              <p>
                また、
                <b>
                  これら問い合わせに対してStripeに質問を行う場合は「Stripe審査部よりお送りしているメールに関してはメールに記載されている方法（メール内リンクより回答・メールに直接返信など）にてご回答」していただく必要がございます。
                </b>
                <br />
                弊社にお問合せいただいても、審査情報保護の観点からStripeよりご回答がいただけないためあらかじめご了承ください。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default index;
